import { render, staticRenderFns } from "./ShaimBalikovna.vue?vue&type=template&id=7649d2f4&scoped=true&"
import script from "./ShaimBalikovna.vue?vue&type=script&lang=js&"
export * from "./ShaimBalikovna.vue?vue&type=script&lang=js&"
import style0 from "./ShaimBalikovna.vue?vue&type=style&index=0&id=7649d2f4&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7649d2f4",
  null
  
)

export default component.exports